import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { ColumnsType } from "antd/lib/table";
import { useEffect } from "react";
import { listarHistoricoContaFinanceira } from "../../../../services/contaFinanceiraService";
import TableComponent from "../../../../components/table/tableComponent";
import { HistoricoContaFinanceiraModel } from "../../../../models/contaFinanceira/historicoContaFinanceiraModel";
import dayjs from "dayjs";

dayjs.locale("pt-br");

const HistoricoContaFinanceira = () => {
  //estados globais
  const contaFinanceiraState = useAppSelector((state) => state.contaFinanceira);

  //hooks
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(listarHistoricoContaFinanceira(contaFinanceiraState.entity.id));
  }, [contaFinanceiraState.entity]);

  const columns: ColumnsType<HistoricoContaFinanceiraModel> = [
    {
      title: "TIPO OPERAÇÃO",
      dataIndex: "tipoOperacao",
      filters: [
        {
          text: "Criação",
          value: "Criação" as any,
        },
        {
          text: "Alteração",
          value: "Alteração" as any,
        },
        {
          text: "Desativação",
          value: "Desativação" as any,
        },
        {
          text: "Ativação",
          value: "Ativação" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.tipoOperacao.toString().includes(value),
    },
    {
      title: "DATA ALTERAÇÃO",
      dataIndex: "dataAlteracao",
      align: "center",
      width: 140,
      sorter: (a: any, b: any) => (dayjs(b.dataAlteracao).isBefore(a.dataAlteracao) ? -1 : 1),
      defaultSortOrder: "descend",
      render: (dataAlteracao: Date) => <>{dayjs(dataAlteracao).format("DD/MM/YYYY HH:mm")}</>,
    },
    {
      title: "USUARIO ALTERAÇÃO",
      dataIndex: "usuarioAlteracao",
      sorter: (a: any, b: any) => a.usuarioAlteracao.localeCompare(b.usuarioAlteracao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "DESCRIÇÃO ALTERAÇÃO",
      dataIndex: "descricaoOperacao",
      sorter: (a: any, b: any) => a.descricaoOperacao.localeCompare(b.descricaoOperacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
  ];

  return <TableComponent data={contaFinanceiraState.listHistorico} columns={columns} loading={contaFinanceiraState.loadingHistorico} />;
};

export default HistoricoContaFinanceira;
